import React from 'react';
import PropTypes from 'prop-types';
import { css } from '@bd/bdui-styles/emotion';
import { withSize } from '@bd/bdcore-utilities';
import { get, uniqBy, uniq } from 'lodash';

import AccordionToggle from '../../components/AccordionToggle';
import { typography, colors } from '../../styles';
import { UnderdogLeftAlt } from '../../helpers/UIElements';

const styles = css`
  @media(min-width: 992px) {
    padding: 0 0 50px;
    position: relative;
  }
  .SmothLink_wrapper {
    @media(min-width: 768px) {
      padding: 50px 0;
      position: absolute;
      top: -50px;
      left: 0;
    }
  }
  .DetailSection_heading {
    @media(min-width: 992px) {
      font-family: ${typography.Serif};
      font-size: 66px;
      color: #212529;
      letter-spacing: 0;
      text-align: left;
      text-transform: capitalize;
      span {
        font-family: ${typography.SansSerif};
        text-transform: uppercase;
        font-style: normal;
        font-weight: 700;
        font-size: 18px;
        color: #4B4B4B;
        letter-spacing: 4px;
        text-align: left;
        margin: 25px 0 0;
      }
    }
  }
  .CommunitySchools_title {
    @media(min-width: 992px) {
      font-family: ${typography.Serif};
      font-size: 28px;
      color: #212529;
      letter-spacing: 0;
      text-align: left;
      text-transform: uppercase;
      letter-spacing: 4px;
    }
  }
  .CommunitySchools_list {
    .CommunitySchools_item {
      font-weight: 700;
      text-transform: none;
      font-size: 14px;
      color: #212529;
      letter-spacing: 0px;
      line-height: 18px;
      display: flex;
      flex-direction: column;
      border-top: 1px solid #AEAEAE;
      span {
        font-weight: 400;
      }
      @media(min-width: 992px) {
        border-top: none;
        border-bottom: 1px solid #d3d3d3;
        transition: all .3s ease;
        font-weight: 700;
        text-transform: uppercase;
        font-size: 14px;
        color: #212529;
        letter-spacing: 3.11px;
        line-height: 18px;
        &:hover {
          border-left: 5px solid ${colors.color1};
        }
      }
    }
    .CommunitySchools_district {
      color: ${colors.color2};
      background-image: none;
      font-size: 16px;
      &:hover {
        border-left: none;
        background-color: transparent;
      }
      @media(min-width: 992) {
        border-bottom: 1px solid #d3d3d3;
      }
    }
  }
`;

function CommunitySchools({ community, size }) {
  const district = (uniq(get(community, 'schools').map(item => get(item, 'district')))[0] || '').replace('School District', '');
  return (
    <div className={styles}>
      <div id="schools" className="SmothLink_wrapper" />
      <AccordionToggle
        openOnId="schools"
        button={({ contentVisible }) => (
          <div className="DetailsSection_btn d-lg-none" role="button" tabIndex={0}>
            <h3 className={`DetailSection_heading ${contentVisible && 'DetailSection_heading-open'}`}>School Info</h3>
          </div>
        )}
      >
        <div className={size.width < 992 && 'container'}>
          <UnderdogLeftAlt className="d-none d-lg-block">
            <h3 className="CommunitySchools_title d-none d-lg-flex flex-column">School Info</h3>
          </UnderdogLeftAlt>
          <ul className="CommunitySchools_list list-unstyled my-3">
            <li className="CommunitySchools_item CommunitySchools_district py-3 p-lg-4">{district}<span>School District</span></li>
            {
              uniqBy(get(community, 'schools', []), 'name').map((item, i) => (
                <li key={i.toString()} className="">
                  <a href={get(item, 'website') || get(item, 'website')} target="_blank" rel="noopener noreferrer" className="CommunitySchools_item py-3 p-lg-4">
                    {get(item, 'name')}
                  </a>
                </li>
              ))
            }
          </ul>
        </div>
      </AccordionToggle>
    </div>
  );
}

CommunitySchools.propTypes = {
  community: PropTypes.object.isRequired,
  size: PropTypes.object.isRequired,
};

export default withSize()(CommunitySchools);



// WEBPACK FOOTER //
// ./src/pages/CommunityDetail/CommunitySchools.js